import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Spinner } from "react-bootstrap";
import { MainLayout } from "./components";
import { LoginForm, MainContent, useAuthStatus, useLogout } from "./modules";

import 'bootstrap/dist/css/bootstrap.min.css';

const queryClient = new QueryClient()

const AuthLoadingState = () => (
  <MainLayout>
    <Spinner animation="border" role="status">
      <span className="visually-hidden">Loading...</span>
    </Spinner>
  </MainLayout>
);

const AuthenticatedApp = () => {
  const { data: authStatus, isPending } = useAuthStatus();
  const { mutate: logout, status: logoutStatus } = useLogout();

  if (isPending || !authStatus) {
    return <AuthLoadingState />;
  }

  return (
    <MainLayout>
      {authStatus?.isAuthenticated ? (
        <MainContent
          title="Skaner katalogów"
          subtitle="Wczytaj katalog danego producenta, uzupełnij opcje i pobierz tabelę."
          isLoggingOut={logoutStatus === "pending"}
          onLogout={() => logout()}
        />
      ) : (
        <LoginForm />
      )}
    </MainLayout>
  );
}

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthenticatedApp />
    </QueryClientProvider>
  );
}

export default App;
